module.exports = __webpack_public_path__ + "img/yishi14.0f96420c.jpg";